import axios from 'axios';

export default class CityService {
  public static async getCityContainingName(name: string): Promise<string[]> {
    return axios.get('/api/cities', { params: { cityName: name } }).then(({ data }) => data);
  }
}
